import React, { useState } from 'react';

function TermsModal({ isOpen, onClose }) {
  const [activeSection, setActiveSection] = useState(null);

  if (!isOpen) return null;

  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };

  return (
    <div className="modal-overlay" onClick={onClose} data-testid="terms-modal">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>ASK STEWIE™ — LEGAL SECTION</h2>
          <button className="modal-close" onClick={onClose} data-testid="close-modal">×</button>
        </div>
        
        <div className="modal-body">
          <p className="last-updated"><em>Last Updated: December 11, 2025</em></p>

          {/* TERMS OF USE ACCORDION */}
          <div className="accordion-item">
            <button 
              className={`accordion-button ${activeSection === 'terms' ? 'active' : ''}`}
              onClick={() => toggleSection('terms')}
              data-testid="terms-accordion"
            >
              Terms of Use
            </button>
            {activeSection === 'terms' && (
              <div className="accordion-panel">
                <p><strong>Last Updated: December 11, 2025</strong></p>

                <p>Welcome to <strong>Ask Stewie™</strong>. By accessing or using the App, you agree to the following Terms of Use.</p>

                <h3>1. License, Not Sale</h3>
                <p>Ask Stewie is licensed, not sold. All intellectual property remains owned by the App provider.</p>

                <h3>2. Intellectual Property Rights</h3>
                <p>Ask Stewie™ is protected by U.S. Copyright, Trademark, and Trade Secret law. Users may not copy, modify, reverse engineer, or create competing software.</p>

                <h3>3. Book-Based Answers</h3>
                <p>Ask Stewie generates answers solely from the book uploaded into the App. Users must verify answers independently.</p>

                <h3>4. Restrictions on Use</h3>
                <p>Users may NOT bypass security, share credentials, upload harmful content, or use the App to build competing technology.</p>

                <h3>5. Updates</h3>
                <p>The App may be updated or modified at any time.</p>

                <h3>6. Termination</h3>
                <p>Access may be terminated for violations, unauthorized use, or non-payment.</p>

                <h3>7. "As Is" Disclaimer</h3>
                <p>The App is provided "AS IS" without warranties of accuracy or reliability.</p>

                <h3>8. Limitation of Liability</h3>
                <p>To the fullest extent allowed by Illinois law, the App provider is not liable for damages or misuse.</p>

                <h3>9. Governing Law</h3>
                <p>These Terms are governed by Illinois law.</p>

                <h3>10. Contact</h3>
                <p>Email: <a href="mailto:info@askstewie.com">info@askstewie.com</a></p>
              </div>
            )}
          </div>

          {/* PRIVACY POLICY ACCORDION */}
          <div className="accordion-item">
            <button 
              className={`accordion-button ${activeSection === 'privacy' ? 'active' : ''}`}
              onClick={() => toggleSection('privacy')}
              data-testid="privacy-accordion"
            >
              Privacy Policy
            </button>
            {activeSection === 'privacy' && (
              <div className="accordion-panel">
                <p><strong>Last Updated: December 11, 2025</strong></p>

                <p>Your privacy is important. This policy explains what information Ask Stewie™ collects and how it is used.</p>

                <h3>1. Information Collected</h3>
                <p>Ask Stewie collects minimal technical data such as device type, questions entered, usage stats, and error logs. It does NOT collect personal identifying information.</p>

                <h3>2. How Information Is Used</h3>
                <p>Data is used only for improving performance, debugging, and analytics. No data is shared or sold.</p>

                <h3>3. Book Input & Answers</h3>
                <p>All answers come solely from the uploaded book. The App does not access the internet for information.</p>

                <h3>4. Security</h3>
                <p>We use encryption and secure processing, but no digital system is 100% secure.</p>

                <h3>5. Workplace Use</h3>
                <p>Employers may see usage activity. The App provider does not access employee activity.</p>

                <h3>6. Children's Privacy</h3>
                <p>The App is not intended for children under 13.</p>

                <h3>7. Policy Updates</h3>
                <p>Updates to this policy may occur. Continued use constitutes acceptance.</p>

                <h3>8. Contact</h3>
                <p>Email: <a href="mailto:info@askstewie.com">info@askstewie.com</a></p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsModal;
